import { useCallback } from 'react';

import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

import { useSegmentSchedulingSelector } from '../Workflows/DisplayWebContent/state/selectors/useSegmentSchedulingSelector';

export const useEndTime = (messageId: string) => {
  const { dispatch } = useCampaignEditorContext();

  const { endTime } = useSegmentSchedulingSelector(messageId) ?? {};
  const onEndTimeChanged = useCallback(
    (endTime: string) => dispatch({ type: 'SET_SEGMENT_END_TIME', payload: { id: messageId, endTime } }),
    [dispatch, messageId],
  );

  return {
    endTime,
    onEndTimeChanged,
  };
};
